/**
 * usePageTracking hook
 *
 * Fires a GA4 page_view event on every route change.
 * Works with React Router v7's useLocation().
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from './gtag';

export function usePageTracking(): void {
  const location = useLocation();

  useEffect(() => {
    // Fire page view on each pathname change
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);
}
